"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_core_1 = require("owa-options-core");
var store_1 = require("../store/store");
var owa_session_store_1 = require("owa-session-store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(function isMessageFormatOptionDirty(state) {
    var optionState = state.optionState, userOptions = state.userOptions;
    return (owa_options_core_1.getFallbackValueIfNull(optionState.showBcc, userOptions.AlwaysShowBcc) !==
        userOptions.AlwaysShowBcc ||
        owa_options_core_1.getFallbackValueIfNull(optionState.showFrom, userOptions.AlwaysShowFrom) !==
            userOptions.AlwaysShowFrom ||
        owa_options_core_1.getFallbackValueIfNull(optionState.composeFormat, userOptions.ComposeMarkup) !==
            userOptions.ComposeMarkup ||
        owa_options_core_1.getFallbackValueIfNull(optionState.fontFamily, userOptions.ComposeFontName) !==
            userOptions.ComposeFontName ||
        owa_options_core_1.getFallbackValueIfNull(optionState.fontSize, userOptions.ComposeFontSize) !==
            userOptions.ComposeFontSize ||
        owa_options_core_1.getFallbackValueIfNull(optionState.fontColor, userOptions.ComposeFontColor) !==
            userOptions.ComposeFontColor ||
        (optionState.isFontBold !== null &&
            !!(userOptions.ComposeFontFlags & 1 /* Bold */) !== optionState.isFontBold) ||
        (optionState.isFontItalic !== null &&
            !!(userOptions.ComposeFontFlags & 2 /* Italic */) !== optionState.isFontItalic) ||
        (optionState.isFontUnderline !== null &&
            !!(userOptions.ComposeFontFlags & 4 /* Underline */) !== optionState.isFontUnderline));
});
//# sourceMappingURL=isMessageFormatOptionDirty.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-message-format-option/lib/utils/isMessageFormatOptionDirty.js
// module id = 5158
// module chunks = 2